module.exports = __webpack_public_path__ + "media/images/flags/be-410c4acc521ec3a598361eacbb8e1557.svg";